import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, Observer, of } from "rxjs";
import { NotificationsService } from "../shared/services/notifications.service";
import { AuthenticationService } from "../shared/services/authentication.service";
import { EmployeeSettingsService } from "../shared/services/employee-settings.service";
import { deleteCookie, getCookie, setCookie } from "../shared/services/caching.service";
import { AuthService } from "./auth.service";
import { Account } from "../shared/models/account";
import { LoginEventsEmitter } from "../shared/events/login.events";
import { AuthenticationManager } from "../shared/managers/authenticationManager";
import { PlatformAwareAuthGuard } from "./platform-aware-auth.guard";
@Injectable({
  providedIn: 'root'
})

export class GuardHelperService {
  private readonly redirectCookieName = 'redirectURL';

  constructor(
    private router: Router,
    private readonly notificationsService: NotificationsService,
    private readonly platformAwareAuthGuard: PlatformAwareAuthGuard,
    private readonly authenticationService: AuthenticationService,
    private readonly employeeSettingsService: EmployeeSettingsService,
    private readonly authService: AuthService,
    private readonly loginEventEmitter: LoginEventsEmitter,
    private readonly authenticationManager: AuthenticationManager
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, checkPermissions: (url: string) => boolean, checkPermissionsForAccount: (account: Account) => boolean = undefined): Observable<boolean> {
    return new Observable<boolean>((observer: Observer<boolean>) => {
      const authResult = this.platformAwareAuthGuard.canActivate(route, state);

      // Handle both Observable and boolean return types
      if (typeof authResult === 'boolean') {
        if (!authResult) {
          this.handleRedirectCookie(state);
          return observer.next(false);
        }

        checkPermissionsForAccount == undefined ?
          this.checkIfEmployeeHasPermissions(observer, state.url.toString(), checkPermissions)
          : this.checkIfEmployeeHasPermissionsForAccount(observer, checkPermissionsForAccount);
      } else {
        (authResult as Observable<boolean | UrlTree>).subscribe((auth: boolean | UrlTree) => {
          if (!auth || typeof auth !== 'boolean') {
            this.handleRedirectCookie(state);
            return observer.next(false);
          }

          //const accountGuid = this.authService.getAccountGuid();
          // if (this.loginEventEmitter.authorizationComplete) {
          //   const account = this.authenticationService.getCurrentAccount();
          //   if (account) {
          //     if (!accountGuid || accountGuid === '0' || accountGuid === '00000000-0000-0000-0000-000000000000' || account.accountUID !== accountGuid) {
          //       this.authenticationManager.authorize();
          //     }
          //   }
          // }

          checkPermissionsForAccount == undefined ?
            this.checkIfEmployeeHasPermissions(observer, state.url.toString(), checkPermissions)
            : this.checkIfEmployeeHasPermissionsForAccount(observer, checkPermissionsForAccount);
        });
      }
    });
  }

  private handleRedirectCookie(state: RouterStateSnapshot) {
    let redirectUrl = getCookie(this.redirectCookieName);
    if (!this.authService.isAuthenticated() && !redirectUrl) {
      console.log(state.url.toString());
      setCookie(this.redirectCookieName, state.url.toString());
    }
    else {
      if (redirectUrl && redirectUrl.length) {
        if (redirectUrl.endsWith('#openNotificationCenter')) {
          redirectUrl = redirectUrl.replace('#openNotificationCenter', '');
          this.notificationsService.forceShowNotifications = true;
        }

        void this.router.navigateByUrl(redirectUrl);
        deleteCookie(this.redirectCookieName);
      }
    }
    return redirectUrl;
  }

  checkIfEmployeeHasPermissions(obs: Observer<boolean>, redirectUrl: string, checkPermissions: (url: string) => boolean) {
    const account = this.authenticationService.getCurrentAccount();
    const employee = this.authenticationService.getCurrentEmployee();

    if (!account || !employee) {
      this.loginEventEmitter.authorizationComplete$.subscribe((res) => {
        if (res) {
          const result = checkPermissions(redirectUrl);

          obs.next(result);
        }
      });
    } else {
      const result = checkPermissions(redirectUrl);
      obs.next(result);
    }
  }

  checkIfEmployeeHasPermissionsForAccount(obs: Observer<boolean>, checkPermissionsForAccount: (account: Account) => boolean) {
    const account = this.authenticationService.getCurrentAccount();
    const employee = this.authenticationService.getCurrentEmployee();

    if (!account || !employee) {
      this.employeeSettingsService.getLoggedInEmployeeForGuards().subscribe((res) => {
        if (res) {
          const result = checkPermissionsForAccount(account);

          obs.next(result);
        }
      });
    } else {
      const result = checkPermissionsForAccount(account);
      console.log(result);
      obs.next(result);
    }
  }
}
